export let QueryKeys = /*#__PURE__*/function (QueryKeys) {
  QueryKeys["Relationship"] = "Relationship";
  QueryKeys["Draft"] = "Draft";
  QueryKeys["ArchivedProposals"] = "ArchivedProposals";
  QueryKeys["CanResyncQbo"] = "CanResyncQbo";
  QueryKeys["CanResyncXero"] = "CanResyncXero";
  QueryKeys["ServiceTemplatesForBilling"] = "ServiceTemplatesForBilling";
  QueryKeys["Contacts"] = "Contacts";
  QueryKeys["ContactsMap"] = "ContactsMap";
  QueryKeys["ActiveServices"] = "ActiveServices";
  QueryKeys["ProposalTemplates"] = "ProposalTemplates";
  QueryKeys["ServiceBillingDetails"] = "ServiceBillingDetails";
  QueryKeys["GetInfo"] = "getInfo";
  QueryKeys["PromptSuggestions"] = "PromptSuggestions";
  return QueryKeys;
}({});